import { ListItemSeparator } from "@similarweb/ui-components";

import * as SC from "app/pages/activation/components/Shared/AutocompleteWebsitesWithKeysControl/styles";
import type { JSX } from "react";

type AutocompleteContentSchema = {
    data: JSX.Element[];
    height: string;
    separatorText: string;
    dataAutomation?: string;
    className?: string;
};

export const AutocompleteContent = ({
    data,
    height,
    dataAutomation,
    className,
    separatorText,
}: AutocompleteContentSchema) => {
    return (
        <>
            <ListItemSeparator data-automation={dataAutomation}>{separatorText}</ListItemSeparator>

            <SC.ScrollContainer
                className={className}
                height={height}
            >
                {data}
            </SC.ScrollContainer>
        </>
    );
};
